/*
 * @Author: 朱亚
 * @Date: 2020-10-10 10:19:09
 * @说明：将所有接口地址导出
 */

import * as accountUrl from './account'
import * as verifyImageUrl from './verifyImage'
import * as fileUploadUrl from './fileUpload'
import * as payUrl from './pay'
import * as customerUrl from './customer'
import * as employeeUrl from './employee'
import * as productUrl from './product'
import * as orderUrl from './order'
import * as financeUrl from './finance'
import * as noticeUrl from './notice'
import * as wxworkUrl from './wxwork'
import * as salesUrl from './sales'
export default {
  accountUrl,
  verifyImageUrl,
  fileUploadUrl,
  payUrl,
  customerUrl,
  employeeUrl,
  productUrl,
  orderUrl,
  financeUrl,
  noticeUrl,
  wxworkUrl,
  salesUrl
}



// WEBPACK FOOTER //
// ./src/api/url/index.js